// extracted by mini-css-extract-plugin
export default {"emissionPlan":"Config_emissionPlan__DIdf7","stickyFooter":"Config_stickyFooter__rjHVc"};